import { customerService, ArchBaseService } from "@/common/api.service";
import {
  GET_CUSTOMER_LIST,
  CUSTOMER_REMITER_GROUPS,
  GET_CUSTOMER_IDSCAN,
  GET_CUSTOMER_IDIMAGES,
  ID_TYPE_LIST,
  GET_CUSTOMER_DETAILS,
  GET_CUSTOMER_IDENTIFICATIONS,
  UPDATE_CUSTOMER_PERSONAL_DETAILS,
  GET_CUSTOMER_ACCOUNT_DETAILS,
  GET_CUSTOMER_ADDRESS,
  UPDATE_CUSTOMER_ADDRESS,
  GET_CUSTOMER_OTHER_DETAILS,
  UPDATE_CUSTOMER_OTHER_DETAILS,
  CUSTOMER_CARD_LIST,
  FRESH_CUSTOMER_LIST,
  GET_CUSTOMER_COMMENTS,
  POST_CUSTOMER_COMMENT,
  UPDATE_CUSTOMER_COMMENT,
  GET_CUSTOMER_ACTIVITY_LOGS,
  GET_CUSTOMER_UPLOADED_DOCUMENTS,
  UPDATE_CUSTOMER_DOCUMENT_STATUS,
  GET_CUSTOMER_UPLOADED_ID_DOCUMENTS,
  RESET_CUSTOMER_PASSWORD,
  CREATE_CUSTOMER_IDENTIFICATION,
  UPDATE_CUSTOMER_IDENTIFICATION,
  UPDATE_CUSTOMER_VERIFICATION,
  RESET_ID_SCAN_ATTEMPTS,
  GET_LOGIN_LOCKOUT_STATUS,
  UNLOCK_CUSTOMER_LOGIN,
  LOCK_CUSTOMER_LOGIN,
  GET_CUSTOMER_DEVICES,
  TRUST_CUSTOMER_DEVICE,
  REVOKE_CUSTOMER_DEVICE,
  GET_ID_REVERIFICATION_CONFIG,
  UPDATE_ID_REVERIFICATION_CONFIG,
  VERIFY_IDSCAN_JOURNEY,
  APPROVE_IDSCAN_JOURNEY,
  GET_REMITTER_CREDIT,
  GET_REMITTER_WALLET_LIST,
  GET_WALLET_HISTORY,
  GET_WALLET_CREDIT_TYPE_LIST,
  POST_CUSTOMER_CREDIT,
  UPDATE_CUSTOMER_CREDIT,
  DELETE_CUSTOMER_CREDIT,
  GET_ACCOUNT_STATUS_LIST,
  GET_LINKED_RISK_BATCH,
  GET_LINKED_RISK_EVIDENCE
} from "./actions.type";
import { SET_ERROR, ISLOADING } from "./mutations.type";
const state = {
  errors: null,
  customer_list: {},
};

const getters = {
  customer_list(state) {
    return state.customer_list;
  },
};

const actions = {
  // get customer list
  async [GET_CUSTOMER_LIST](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.get(`customer/list/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  async [GET_CUSTOMER_IDENTIFICATIONS](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.get(`customer/${payload}/identifications`)
        .then((data) => {
          resolve(data);
        })
        .catch((response) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // get customer ID & account details
  async [GET_CUSTOMER_ACCOUNT_DETAILS](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.get(`customer/idaccount/${payload}`)
        .then((data) => {
          resolve(data);
        })
        .catch((response) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // get remitter group
  async [CUSTOMER_REMITER_GROUPS]() {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    const data = await ArchBaseService.get("customer/group");
    return data;
  },

  // get account status list
  async [GET_ACCOUNT_STATUS_LIST]() {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    const data = await ArchBaseService.get("customer/get-account-statuses");
    return data;
  },

  // get id types list
  async [ID_TYPE_LIST](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    return new Promise((resolve) => {
      ArchBaseService.get(`customer/id-type-list/${payload}`)
        .then((data) => {
          resolve(data);
        })
        .catch((response) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // get Customer Personal Details
  async [GET_CUSTOMER_DETAILS](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    return new Promise((resolve) => {
      ArchBaseService.get(`customer/details/${payload}`)
        .then((data) => {
          resolve(data);
        })
        .catch((response) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Update Customer Personal Details
  async [UPDATE_CUSTOMER_PERSONAL_DETAILS](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    return new Promise((resolve) => {
      ArchBaseService.put(`customer/personal-info/${payload.id}`, payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // get Customer Address
  async [GET_CUSTOMER_ADDRESS](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    // context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.get(`customer/adresses/${payload}`)
        .then((data) => {
          resolve(data);
        })
        .catch((response) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // update Customer Address
  async [UPDATE_CUSTOMER_ADDRESS](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      if (!payload.addressId) {
        // ArchBaseService.post(`customer/add-address/?customer_id=${payload.customer_id}`,payload)
        // .then(( data ) => {
        //   context.commit(ISLOADING, false);
        //   resolve(data);
        // })
        // .catch(({ response }) => {
        //   context.commit(ISLOADING, false);
        //   resolve(response);
        // });
      } else {
        ArchBaseService.put(`customer/address/${payload.customer_id}`, payload)
          .then((data) => {
            context.commit(ISLOADING, false);
            resolve(data);
          })
          .catch(({ response }) => {
            context.commit(ISLOADING, false);
            resolve(response);
          });
      }
    });
  },

  // get ID Documents Uploaded in IDScan
  async [GET_CUSTOMER_IDSCAN](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    return new Promise((resolve) => {
      ArchBaseService.get(`customer/idScan/${payload}`)
        .then((data) => {
          //   context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch((response) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // get ID Documents Images from new API endpoint
  async [GET_CUSTOMER_IDIMAGES](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    return new Promise((resolve) => {
      ArchBaseService.get(`customer/idImages/${payload}`)
        .then((data) => {
          //   context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch((response) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // get Customer Other Details
  async [GET_CUSTOMER_OTHER_DETAILS](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    // context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.get(`customer/other-details/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch((response) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Update Customer Other Details
  async [UPDATE_CUSTOMER_OTHER_DETAILS](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    try {
      return await ArchBaseService.put(
        `customer/other-details/${payload.customerId}`,
        payload,
      );
    } catch (err) {
      context.commit(ISLOADING, false);
      return err.response;
    }
  },

  async [FRESH_CUSTOMER_LIST]() {
    // StandappServiceV2.init();
    // StandappServiceV2.setHeader();
    // context.commit(ISLOADING, true);
    // const data = await StandappServiceV2.get('user/customer-groups');
    // context.commit(ISLOADING, false);
    // return data;
  },

  // customer Card List
  async [CUSTOMER_CARD_LIST](context, payload) {
    customerService.init();
    customerService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      customerService
        .get(`customer/payment/get-cards/?customerid=${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // customer comments
  async [GET_CUSTOMER_COMMENTS](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.get(`customer/get-comment/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
  // Store Customer comments
  async [POST_CUSTOMER_COMMENT](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    return new Promise((resolve) => {
      ArchBaseService.post(`customer/store-comment`, payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
  // Update Customer comments
  async [UPDATE_CUSTOMER_COMMENT](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    return new Promise((resolve) => {
      ArchBaseService.put(
        `customer/update-comment/${payload.commentid}/${payload.customerid}`,
        payload,
      )
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Get Customer Activity Logs (Bearer token automatically added via axios interceptor)
  async [GET_CUSTOMER_ACTIVITY_LOGS](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    return new Promise((resolve) => {
      ArchBaseService.get(`user-activity/logs/${payload}/customer`)
        .then((data) => {
          resolve(data);
        })
        .catch(({ response }) => {
          resolve(response);
        });
    });
  },

  // Get Customer Uploaded Documents (Bearer token automatically added via axios interceptor)
  async [GET_CUSTOMER_UPLOADED_DOCUMENTS](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    const { customerId, queryParams } = payload;
    return new Promise((resolve) => {
      ArchBaseService.get(`customer/${customerId}/documents${queryParams || ''}`)
        .then((data) => {
          resolve(data);
        })
        .catch(({ response }) => {
          resolve(response);
        });
    });
  },

  // Update Customer Document Status (Bearer token automatically added via axios interceptor)
  async [UPDATE_CUSTOMER_DOCUMENT_STATUS](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    const { documentId, action, admin_comment } = payload;
    return new Promise((resolve) => {
      ArchBaseService.put(`customer/documents/${documentId}/action`, {
        action,
        admin_comment
      })
        .then((data) => {
          resolve(data);
        })
        .catch(({ response }) => {
          resolve(response);
        });
    });
  },

  // Get Customer Uploaded ID Documents (Bearer token automatically added via axios interceptor)
  async [GET_CUSTOMER_UPLOADED_ID_DOCUMENTS](context, customerId) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    return new Promise((resolve) => {
      ArchBaseService.get(`customer/${customerId}/id-documents`)
        .then((data) => {
          resolve(data);
        })
        .catch(({ response }) => {
          resolve(response);
        });
    });
  },

  // Reset Customer Password (Bearer token automatically added via axios interceptor)
  async [RESET_CUSTOMER_PASSWORD](context, customerId) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    return new Promise((resolve) => {
      ArchBaseService.post(`customer/reset-password/${customerId}`)
        .then((data) => {
          resolve(data);
        })
        .catch(({ response }) => {
          resolve(response);
        });
    });
  },

  // Get the customer's current login-lockout status (drives the CE unlock confirmation)
  async [GET_LOGIN_LOCKOUT_STATUS](context, customerId) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    return new Promise((resolve) => {
      ArchBaseService.get(`customer/${customerId}/login-lockout`)
        .then((data) => {
          resolve(data);
        })
        .catch(({ response }) => {
          resolve(response);
        });
    });
  },

  // Unlock a customer's login lockout after phone validation (permission-gated + audited server-side)
  async [UNLOCK_CUSTOMER_LOGIN](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    return new Promise((resolve) => {
      ArchBaseService.post(`customer/${payload.customerId}/unlock-login`, {
        reason: payload.reason,
        notes: payload.notes,
      })
        .then((data) => {
          resolve(data);
        })
        .catch(({ response }) => {
          resolve(response);
        });
    });
  },

  // Manually lock a customer's login (permission-gated + audited server-side)
  async [LOCK_CUSTOMER_LOGIN](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    return new Promise((resolve) => {
      ArchBaseService.post(`customer/${payload.customerId}/lock-login`, {
        reason: payload.reason,
        notes: payload.notes,
      })
        .then((data) => {
          resolve(data);
        })
        .catch(({ response }) => {
          resolve(response);
        });
    });
  },

  // List a customer's registered devices + trust status (drives the Trust Device confirmation)
  async [GET_CUSTOMER_DEVICES](context, customerId) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    return new Promise((resolve) => {
      ArchBaseService.get(`customer/${customerId}/devices`)
        .then((data) => {
          resolve(data);
        })
        .catch(({ response }) => {
          resolve(response);
        });
    });
  },

  // Trust a specific Customer Device after phone validation (permission-gated + audited server-side)
  async [TRUST_CUSTOMER_DEVICE](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    return new Promise((resolve) => {
      ArchBaseService.post(`customer/${payload.customerId}/devices/trust`, {
        deviceId: payload.deviceId,
        reason: payload.reason,
        notes: payload.notes,
      })
        .then((data) => {
          resolve(data);
        })
        .catch(({ response }) => {
          resolve(response);
        });
    });
  },

  // Revoke a Customer Device's trust (permission-gated + audited server-side)
  async [REVOKE_CUSTOMER_DEVICE](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    return new Promise((resolve) => {
      ArchBaseService.post(`customer/${payload.customerId}/devices/revoke`, {
        deviceId: payload.deviceId,
        reason: payload.reason,
        notes: payload.notes,
      })
        .then((data) => {
          resolve(data);
        })
        .catch(({ response }) => {
          resolve(response);
        });
    });
  },

  // Create customer identification document
  async [CREATE_CUSTOMER_IDENTIFICATION](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.post(
        `customer/${payload.customerId}/identification`,
        payload,
      )
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Update customer identification document
  async [UPDATE_CUSTOMER_IDENTIFICATION](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.put(
        `customer/${payload.customerId}/identification/${payload.identificationId}`,
        payload,
      )
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Update customer verification/account details
  async [UPDATE_CUSTOMER_VERIFICATION](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.put(
        `customer/${payload.customerId}/verification`,
        payload,
      )
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Reset ID scan attempts for customer
  async [RESET_ID_SCAN_ATTEMPTS](context, customerId) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.post(`customer/${customerId}/account/reset-scan-attempts`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Get ID reverification config for a customer
  async [GET_ID_REVERIFICATION_CONFIG](context, customerId) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.get(`customer/${customerId}/id-reverification`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Update ID reverification config for a customer
  async [UPDATE_ID_REVERIFICATION_CONFIG](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.put(`customer/${payload.customerId}/id-reverification`, {
        requireIdReverification: payload.requireIdReverification,
      })
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Verify a completed IDScan journey and upgrade the customer to Silver
  async [VERIFY_IDSCAN_JOURNEY](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.create(
        `customer/${payload.customerId}/id-scan/${payload.journeyId}`,
      )
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Ops have judged a document sound that the system did not accept on its own. The reason is
  // required: the audit middleware records request bodies, so who decided, when and why are
  // captured together.
  async [APPROVE_IDSCAN_JOURNEY](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.create(
        `customer/${payload.customerId}/id-scan/${payload.journeyId}/approve`,
        { reason: payload.reason },
      )
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Get customer credit
  async [GET_REMITTER_CREDIT](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.get(`customer/credit-wallet-list?${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Get wallet transaction history (full ledger)
  async [GET_WALLET_HISTORY](context, { customerid, params }) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    const query = new URLSearchParams();
    Object.entries(params || {}).forEach(([k, v]) => {
      if (v !== null && v !== undefined && v !== "") query.append(k, v);
    });
    return new Promise((resolve) => {
      ArchBaseService.get(`customer/${customerid}/wallet-history?${query.toString()}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Get customer wise wallet list
  async [GET_REMITTER_WALLET_LIST](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.get(`customer/get-wallet-list/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Get wallet credit type list
  async [GET_WALLET_CREDIT_TYPE_LIST](context) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.get(`customer/get-wallet-credit-type`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Store Customer credit
  async [POST_CUSTOMER_CREDIT](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    return new Promise((resolve) => {
      ArchBaseService.post(`customer/store-credit`, payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
  // Update Customer credit
  async [UPDATE_CUSTOMER_CREDIT](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    return new Promise((resolve) => {
      ArchBaseService.put(
        `customer/update-credit/${payload.creditid}`,
        payload,
      )
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Delete Customer credit
  async [DELETE_CUSTOMER_CREDIT](context, payload) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    return new Promise((resolve) => {
      ArchBaseService.put(
        `customer/delete-credit/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Linked-risk summaries for a bounded batch of remitters (current list page only)
  async [GET_LINKED_RISK_BATCH](context, customerIds) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    return new Promise((resolve) => {
      ArchBaseService.post(`customer/linked-risk/batch`, { customerIds })
        .then((data) => {
          resolve(data);
        })
        .catch(({ response }) => {
          resolve(response);
        });
    });
  },

  // Linked-risk evidence breakdown for one remitter ("Why is this risky?")
  async [GET_LINKED_RISK_EVIDENCE](context, customerId) {
    ArchBaseService.init();
    ArchBaseService.setHeader();
    return new Promise((resolve) => {
      ArchBaseService.get(`customer/linked-risk/${customerId}/evidence`)
        .then((data) => {
          resolve(data);
        })
        .catch(({ response }) => {
          resolve(response);
        });
    });
  },
};
const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [ISLOADING](state, loading) {
    state.isLoading = loading;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
